import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ChangeStoreModal from "../Modal/ChangeStore";
// import { $confirmDialog } from "../../dialog/confirmDialog";
import { $confirmDialog } from "../dialog/confirmDialog";
import { useTranslation } from "react-i18next";
import useChangeStore from "../../hooks/useChangeStore";
import useSelectedStore from "../../hooks/useSelectedStore";
import useReduxData from "../../hooks/useReduxData";
import useLogoFevIcon from "../../hooks/useLogoFevIcon";
export default function Logo() {
  const { t } = useTranslation();
  const { resetStore } = useChangeStore();
  const { selectedStore, isStoreSelected, allStore } = useSelectedStore();
  const { logo, fevicon } = useLogoFevIcon()
  const redux_data = useReduxData();
  const { isShowStoreNameHeader, isShowMobileSearch } = redux_data.commonData;

  useEffect(() => {


    const link: HTMLLinkElement =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "icon";
    link.href = fevicon;
    document.head.appendChild(link);
  }, [selectedStore, fevicon]);


  const changeStore = async () => {
    let res = await $confirmDialog(
      t("Home.areYouSureYouWantToChangeStore"),
      "",
      t("Home.no"),
      t("Home.yes")
    );
    console.log("_resres", res);
    if (res) {
      resetStore();
    }
  };

  const logoUrl = useMemo(() => {
    return logo;
  }, [selectedStore])

  return (
    <>
      <Link
        to={"/menu"}
        className="flex items-center gap-2 md:gap-3 cursor-pointer"
      >
        {/* Change Store Text */}

        {/* Logo */}
        <div className="md:min-w-36 min-w-10 h-10 flex justify-start items-center">
          <img
            src={logoUrl}
            alt="Logo"
            className="w-auto h-full mobile-head-logo-all-resturant"
          />


          {!isShowStoreNameHeader && isStoreSelected && allStore?.length > 1 && (
            <span
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                changeStore();
              }}
              className=" ms-2 pt-1 text-[#34558b] text-sm md:text-base font-semibold hover:underline"
            >
              {isStoreSelected && "Change store"}
            </span>
          )}
        </div>
      </Link>

      {/* {isClear && (
        <ChangeStoreModal
          orderOnline={isClear}
          setOrderOnline={setIsClear}
          cancelChangeStore={cancelChangeStore}
          clearData={clearData}
        />
      )} */}
    </>
  );
}
